import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTermsStatus } from '../api/terms';

const SELLER_ROLES = ['organizer', 'artist', 'venue'];

const SellerRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [checkingTerms, setCheckingTerms] = useState(true);
  const [requiresReagreement, setRequiresReagreement] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!user || !SELLER_ROLES.includes(user.role)) {
      setCheckingTerms(false);
      setRequiresReagreement(false);
      return;
    }

    const checkStatus = async () => {
      setCheckingTerms(true);
      try {
        const status = await getTermsStatus();
        if (!cancelled) {
          setRequiresReagreement(!!status?.requires_reagreement);
        }
      } catch (e) {
        if (!cancelled) {
          setRequiresReagreement(false);
        }
      } finally {
        if (!cancelled) setCheckingTerms(false);
      }
    };

    checkStatus();

    return () => {
      cancelled = true;
    };
  }, [user]);

  if (loading) {
    return <p>認証チェック中...</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!SELLER_ROLES.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  if (checkingTerms) {
    return null;
  }

  if (requiresReagreement) {
    const rawNext = `${location.pathname}${location.search || ''}`;
    let safeNext = '/profile/my';
    try {
      const url = new URL(rawNext, window.location.origin);
      if (url.origin === window.location.origin) safeNext = rawNext;
    } catch {
      // フォールバック
    }
    return <Navigate to={`/terms/reagreement?next=${encodeURIComponent(safeNext)}`} replace />;
  }

  return children;
};

export default SellerRoute;
